<template>
  <div class="bar_blog">
    <el-row :gutter="0" class="dashed">
      <el-col :span="12">
        <div class="grid-content bg-purple title1">
          {{type_title}}<template v-if="type == 'email' || type == 'phone' || type == 'password'">{{ is_bild ? '修改' : '修改'}}</template><template v-else>{{ is_bild ? '修改' : '上传'}}</template>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <template >
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <!-- 密码修复 -->
            <template v-if="type == 'password'">
              <el-form-item label="原始密码" prop="address">
                <el-input type="password" v-model="ruleForm.address"></el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="password">
                <el-input type="password" v-model="ruleForm.password"></el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="checkPass">
                <el-input type="password" v-model="ruleForm.checkPass"></el-input>
              </el-form-item>
            </template>

            <!-- 手机号修改 -->
            <template v-if="type == 'phone'">
              <el-form-item label="旧手机号" prop="telphone">
                <!-- <el-input type="text" v-model="ruleForm.telphone"></el-input> -->
                {{JiuTel}}
              </el-form-item>
              <el-form-item label="验证码" prop="code">
                <el-input type="text" v-model="ruleForm.code"></el-input>
                <el-button type="primary" :disabled="is_disable" round :plain="false" @click="getCode()" class="get-code">
                  <span v-if="sendMsgDisabled">{{time+'秒后获取'}}</span>
                  <span v-if="!sendMsgDisabled">发送验证码</span>
                </el-button>
              </el-form-item>
              <el-form-item label="新手机号" prop="phone">
                <el-input type="text" v-model="ruleForm.phone"></el-input>
              </el-form-item>
            </template>

            <template v-if="type == 'email'">
               <el-form-item label="手机号" prop="telphone">
                <!-- <el-input type="text" v-model="ruleForm.telphone"></el-input> -->
                {{JiuTel}}
              </el-form-item>
              <!-- <el-form-item label="手机号" prop="telphone">
                <el-input type="text" v-model="ruleForm.telphone"></el-input>
              </el-form-item> -->
              <el-form-item label="验证码" prop="code">
                <el-input type="text" v-model="ruleForm.code"></el-input>
                <el-button type="primary" :disabled="is_disable" round :plain="false" @click="getCode()" class="get-code">
                  <span v-if="sendMsgDisabled">{{time+'秒后获取'}}</span>
                  <span v-if="!sendMsgDisabled">发送验证码</span>
                </el-button>
              </el-form-item>
              <el-form-item label="邮箱" prop="email">
                <el-input type="text" v-model="ruleForm.email"></el-input>
              </el-form-item>
            </template>

            <template v-if="type == 'personcard' || type == 'auth' || type == 'guide' || type == 'other'">
              <el-form-item :label="type_title" :prop="photo_type_props">
                <el-upload
                  class="uploader-img"
                  action="https://api.peibanwan.com/pbw-interface/common/uploadFileToOSS"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="imageUrl" :src="imageUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon el-border"></i>
                </el-upload>
              </el-form-item>
            </template>


            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">提交修改</el-button>
            </el-form-item>

          </el-form>
        </template>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import {selectUserDetailByProof,updateUserPasswrod,insertUserProof} from "api/apis";
  export default {
    data() {
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      var validateTelphone = (rule, value, callback) => {
        if (!(/^1[34578]\d{9}$/.test(value))) {
          return callback(new Error('请输入正确的手机号码'))
        } else {
          callback()
        }
      };
      var validateCode = (rule, value, callback) => {
        if (!(/^\d{6}$/.test(value))) {
          return callback(new Error('请输入正确的验证码'))
        } else {
          callback()
        }
      };
      var validatePhone = (rule, value, callback) => {
        if (!(/^1[34578]\d{9}$/.test(value))) {
          return callback(new Error('请输入正确的手机号码'))
        } else if (value == this.ruleForm.telphone) {
          return callback(new Error('请不要输入相同的手机号！'))
        } else {
          callback()
        }
      };
      var validateEmail = (rule, value, callback) => {
        if (!(/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(value))) {
          return callback(new Error('请输入正确的邮箱地址！'))
        } else {
          callback()
        }
      }
      return { 
        imgHead:{
          code: localStorage.getItem("pbw_user_pc_uid"),
          loginType: '1',
        },
        is_disable: false, //控制按钮是否禁止点击 
        sendMsgDisabled: false,
        time: 60,
        typeArr: [
          {name: '密码', type: 'password'},
          {name: '手机', type: 'phone'},
          {name: '邮箱', type: 'email'},
          {name: '身份证', type: 'personcard'},
          {name: '导游证', type: 'guide'},
          {name: '宣传照片', type: 'auth'},
          {name: '其他证件', type: 'other'},
        ],
        user_code: localStorage.getItem('pbw_user_pc_uid'),
        type_title: '',
        type: '',
JiuTel:'',
        ruleForm:{
          address: '',
          password: '',
          checkPass: '',
          telphone: '',
          code: '',
          phone: '',
          email: '',
          proofImgPath: '',//身份证件照片
          guideImgPath: '',//导游证
          userImgPath: '',//认证照
          otherImgPath: '',//其他
        },
        rules:{
          address: [
            { required: true, message: '请输入您的原始密码！', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请输入您的新密码！', trigger: 'blur' },
          ],
          checkPass: [
            { required: true, message: '请再次输入您的新密码！', trigger: 'blur' },
            { validator: validatePass2, trigger: 'blur' }
          ],

          telphone: [
            { required: true, message: '请输入您的手机号！', trigger: 'blur' },
            { validator: validateTelphone, trigger: 'blur' }
          ],
          code:[
            { required: true, message: '请输入您的验证码！', trigger: 'blur' },
            { validator: validateCode, trigger: 'blur' }
          ],
          phone:[
            { required: true, message: '请输入您的新手机号！', trigger: 'blur' },
            { validator: validatePhone, trigger: 'blur' }
          ],
          email:[
            { required: true, message: '请输入您的邮箱！', trigger: 'blur' },
            { validator: validateEmail, trigger: 'blur' }
          ],
          proofImgPath:[
            { required: true, message: '请上传您的身份证正面照片！', trigger: 'blur' },
          ],
          guideImgPath:[
            { required: true, message: '请上传您的导游证正面照片！', trigger: 'blur' },
          ],
          userImgPath:[
            { required: true, message: '请上传您的认证照正面照片！', trigger: 'blur' },
          ],
          otherImgPath:[
            { required: true, message: '请上传您的其他照片！', trigger: 'blur' },
          ]
        },
        getUserSaveInforAjax: {},
        is_bild: false,

        imageUrl: '',//身份证
        photo_type_props: '',
      }
    },
    methods: {     
      handleAvatarSuccess(res, file) {
        console.log(res,"回传成功")
        this.imageUrl = URL.createObjectURL(file.raw);
        if(this.type == 'personcard'){
          this.ruleForm.proofImgPath = res.data.ossFileName
        }
        if(this.type == 'guide'){
          this.ruleForm.guideImgPath = res.data.ossFileName
        }
        if(this.type == 'auth'){
          this.ruleForm.userImgPath = res.data.ossFileName
        }
        if(this.type == 'other'){
          this.ruleForm.otherImgPath = res.data.ossFileName
        }
      },
      beforeAvatarUpload(file) {
        // 上传格式判断
        if (!/.(jpg|jpeg|png|bmp|JPG|JPEG|PNG|BPM)$/.test(file.name)) {
          this.$message.error('文件格式只能是jpeg、jpg、PNG、bmp中的一种!')
          return false
        }
        if (file.size > 100 * 1024 * 1024) {
          this.$message.error('文件大小超过限制')
          return false
        }
        const loading = this.$loading({
          lock: true,
          text: '上传中～',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 1500);
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {}
            if (this.type == 'password') {//密码
              params = {
                uid: this.user_code,
                oldPwd: this.ruleForm.address,
                password: this.ruleForm.password,
              }
              updateUserPasswrod(params).then((res) => {
                if (res.code == '000000') {
                  this.user_code = ''
                  this.ruleForm.address = ''
                  this.ruleForm.password = ''
                  this.$message.success("密码修改成功！")
                  this.$router.go(-1)
                } else {
                  this.$message.warning(res.msg ? res.msg : '数据加载中，请稍后')
                }
              })
            }

            if (this.type == 'phone') {//手机
              params = {
                telphone: this.ruleForm.telphone,
                address: this.ruleForm.code,
                homeCityStr: this.ruleForm.phone
              }
              userInfo_updateUserTelphone(params).then((res) => {
                if (res.repCode == '000000') {
                  this.$message.success("手机号修改成功！")
                     this.$router.go(-1)
                } else {
                  this.$message.warning(res.repMsg ? res.repMsg : '数据加载中，请稍后')
                }
              })
            }
            if (this.type == 'email') {
              params = {
                telphone: this.ruleForm.telphone,
                address: this.ruleForm.code,
                email: this.ruleForm.email
              }
              if (this.is_bild) {//已绑定邮箱
                userInfo_updateUserEmail(params).then((res) => {
                  if (res.repCode == '000000') {
                    this.$message.success("邮箱修改成功！")
                    this.is_bild = true
                  } else {
                    this.$message.warning(res.repMsg ? res.repMsg : '数据加载中，请稍后')
                  }
                })
              } else {//未绑定邮箱
                userInfo_insertUserEmail(params).then((res) => {
                  if (res.repCode == '000000') {
                    this.$message.success("邮箱绑定成功！")
                  } else {
                    this.$message.warning(res.repMsg ? res.repMsg : '数据加载中，请稍后')
                  }
                })
              }
            }

            // if(this.type == 'personcard'){
            //   this.ruleForm.proofImgPath = res.data.fileStr
            // }
            // if(this.type == 'guide'){
            //   this.ruleForm.guideImgPath = res.data.fileStr
            // }
            // if(this.type == 'auth'){
            //   this.ruleForm.userImgPath = res.data.fileStr
            // }
            // if(this.type == 'other'){
            //   this.ruleForm.otherImgPath = res.data.fileStr
            // }
            
            if (this.type == 'personcard' || this.type == 'guide' || this.type == 'auth' || this.type == 'other') {
              params.userCode = this.user_code
              params.proofImgPath = this.ruleForm.proofImgPath
              params.guideImgPath = this.ruleForm.guideImgPath
              params.userImgPath = this.ruleForm.userImgPath
              params.otherImgPath = this.ruleForm.otherImgPath
            
              insertUserProof(params).then((res) => {
                if (res.code == '000000') {
                  this.$message.success("上传成功！")
                } else {
                  this.$message.warning(res.msg ? res.msg : '数据加载中，请稍后')
                }
              })
            }

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      getCode () {
        let vm = this
        console.log("发送");
        if(this.ruleForm.telphone == '' || !(/^1[34578]\d{9}$/.test(this.ruleForm.telphone)) || this.ruleForm.telphone.length < 11){
          this.$message.error("请输入正确手机号");
          return
        }
        this.sendMsgDisabled = true;
        this.is_disable = true; //倒计时禁止点击
        let interval = window.setInterval(() => {
          if ((this.time--) <= 0) {
            this.time = 60;
            this.sendMsgDisabled = false;
            this.is_disable = false;
            window.clearInterval(interval);
          }
        }, 1000);
        userInfo_insertUserSendSMS({'telphone':this.ruleForm.telphone,'status': 2}).then((res)=>{
          if(res.code == '000000'){
            this.$message.success("已发送，请查收");
          } else if (res.code == '888888') {
            this.$message.warning("请不要输入相同的手机号！");
          } else {
            this.$message.error(res.msg);
            this.sendMsgDisabled = false;
            this.is_disable = false;
          }
        })
      },
      getUserSaveInfor () {
        selectUserDetailByProof({userCode: this.user_code}).then((res) => {
          if (res.code == '000000') {
            this.getUserSaveInforAjax = res.data
            //邮箱
            if (this.$route.query.type == 'email' && res.data.checkStatus == 1) {
              this.is_bild = true
            }
            //密码
            if (this.$route.query.type == 'password') {
              this.is_bild = true
            }
            //手机
            if (true) {
              this.is_bild = true
              this.JiuTel = res.data.guideNumber
              this.ruleForm.telphone = res.data.guideNumber
            }
            //身份证
            if (this.$route.query.type == 'personcard') {
              this.imageUrl = res.data.proofImgPath
              if (res.data.proofImgPath && res.data.proofImgPath != '') {
                this.is_bild = true
              }
            }
            //导游证
            if (this.$route.query.type == 'guide') {
              this.imageUrl = res.data.guideImgPath
              if (res.data.guideImgPath && res.data.guideImgPath != '') {
                this.is_bild = true
              }        
            }
            //认证照片
            if (this.$route.query.type == 'auth' ) {
              this.imageUrl = res.data.userImgPath
              if (res.data.userImgPath && res.data.userImgPath != '') {
                this.is_bild = true
              }
            }
            //其他照片
            if (this.$route.query.type == 'other') {
              this.imageUrl = res.data.otherImgPath
              if (res.data.otherImgPath && res.data.otherImgPath != '') {
                this.is_bild = true
              }
            }
          } else {
            this.$message.warning(res.msg ? res.msg : '数据加载中，请稍后')
          }
        })
      },
    },
    created () {
      this.$nextTick(() => {
        //获取用户权限
        this.getUserSaveInfor()
        //标题
        for (let item of this.typeArr) {
          if (item.type == this.$route.query.type) {
            this.type_title = item.name
          }
        }
        //类型
        this.type = this.$route.query.type

        if (this.$route.query.type == 'personcard') {
          this.photo_type_props = 'proofImgPath'
        }
        if (this.$route.query.type == 'guide') {
          this.photo_type_props = 'guideImgPath'
        }
        if (this.$route.query.type == 'auth') {
          this.photo_type_props = 'userImgPath'
        }
        if (this.$route.query.type == 'other') {
          this.photo_type_props = 'otherImgPath'
        }
      }) 
    }
  }
</script>
<style>
  .el-upload-list__item-name{
    display: none;
  }
</style>
<style lang="scss" scoped>
  @import '../../../src/scss/commonH5.scss';
  @import '../../scss/demo.scss';
  .avatar{
    height: 180px;
    width: 180px;
    border-radius: 90px;
    border: 1px solid #d6d6d6;
  }
  .bar_blog .dashed {
    border-bottom: 1px dashed #F1F1F1;
    padding-bottom: 20px;
    margin-bottom: 25px;
  }
  .bar_blog .title1 {
    font-size: 18px;
    color: #333;
  }
  .bar_blog .title1::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 27px;
    border-radius: 5px;
    vertical-align: bottom;
    background-color: #F16202;
    margin-right: 20px;
  }
  .bar_blog .title2, .bar_blog .title2 em {
    text-align: right;
    font-size: 14px;
    color: #959595;
    line-height: 27px;
  }
  .get-code{
    border-radius: 0px;
    width: 88px;
    padding: 12px 0px;
    position: absolute;
    top: 0px;
    right: 0px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .uploader-img .el-upload{
    
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .uploader-img .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    /*background: url(/static/images/phone.jpeg) no-repeat;*/
    background-size: cover;
    border-radius: 90px;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/modifyInfor.vue